import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const members = {
  total_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/total_members", params),
  total_members_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/members/total_members_by_date",
      params,
    ),
  active_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/active_members", params),
  active_members_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/members/active_members_by_date",
      params,
    ),
  new_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/new_members", params),
  new_members_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/members/new_members_by_date",
      params,
    ),
  activity_scores: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/activity_scores", params),
  member_distribution_by_country: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/members/member_distribution_by_country",
      params,
    ),
  top_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/top_members", params),
  active_commenters: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/active_commenters", params),
  post_starters: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/post_starters", params),
  most_appreciated: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/members/most_appreciated", params),
  popular_day_and_time: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/members/popular_day_and_time",
      params,
    ),
};
